import React from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { AgentFormState } from "../../../types/agentTypes";

type ClosedAgentAlertProps = {
  formData: AgentFormState;
};

const ClosedAgentAlert = ({ formData }: ClosedAgentAlertProps) => {
  const { t } = useTranslation();

  if (formData.is_o) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mt: -2 }}>
      {t("createAgent.closedAgentAlert.closedOn", {
        date: dayjs(formData.data_end_doc).format("DD.MM.YYYY"),
      })}
    </Alert>
  );
};

export default ClosedAgentAlert;
